<template src="./summary-dim-select.html"></template>

<script lang="ts">
import { localizedThousandsInteger } from 'util/localization-utils'

export default {
  props: {
    dim: Object, // SummaryDimension
    dimFiltersOn: Boolean,
    headingLevel: { type: Number, default: 3 }
  },
  emits: ['setFilter'],
  computed: {
    values() {
      return this.dim && this.dim.values ?
        this.dim.values.filter(d => d.count > 0)
          .map((d) => {
            return { id: d.id, label: d.label, count: localizedThousandsInteger(d.count) }
          }) : []
    },
    valuesAsText() {
      return this.values.map(v => `${v.label} (${(v.count)})`).join(', ')
    }
  },
  methods: {
    filterBy(dimVal) {
      this.$emit('setFilter', 'dm', this.dim.dimensionDefinitionId.toString(), dimVal.id, this.dim)
    }
  }
}
</script>

<style lang="scss" src="./summary-dim.scss"></style>
<style lang="scss" src="./summary-dim-select.scss"></style>
